import { render } from "./TagThird.vue?vue&type=template&id=1cfe1645&scoped=true"
import script from "./TagThird.vue?vue&type=script&lang=js"
export * from "./TagThird.vue?vue&type=script&lang=js"

import "./TagThird.vue?vue&type=style&index=0&id=1cfe1645&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfe1645"]])

export default __exports__